import {LitElement, html, css} from 'lit';
import {connect} from 'pwa-helpers';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';
import {classMap} from 'lit/directives/class-map.js';
import {when} from 'lit/directives/when.js';
import {repeat} from 'lit/directives/repeat.js';
import {msg} from '@lit/localize';
import familyConfig from '../../familyConfig';
import store from '../../store';
import down from '../../../icons/down';
import {selectFamily, selectFamilyConfig} from '../../selectors';

@customElement('family-selector')
export class FamilySelector extends connect(store)(LitElement) {

	static styles = css`
		:host {}
		.familySelector {
			position: relative;
		}
		.familySelectorLabel {
			font: var(--font-small-title);
			font-size: 27px;
			font-weight: bold;
			background-color: transparent;
			border-bottom: 1px solid var(--fix-color-border);
			color: var(--fix-color-white);
			display: flex;
			justify-content: space-between;
			flex-direction: row;
			gap: var(--small-padding);
			cursor: pointer;
		}
		.text {

		}
		.icon {
			color: var(--fix-color-white);
		}
		.familySelectorOptions {
			display: none;
			flex-direction: column;
			gap: 0;
			background-color: var(--fix-color-black);
			border: 1px solid var(--fix-color-border);
			height: 350px;
			overflow-y: auto;
			position: absolute;
			z-index: 9999;
			left: 0;
			top: 97%;
			width: 100%;
			min-width: 200px;
			box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.25);
		}
		.familySelectorOptions.active {
			display: flex;
		}

		.familySelectorOption {
			padding: var(--very-small-padding) var(--small-padding);
			font: var(--font-light);
			color: var(--fix-color-white);
			display: block;
			text-decoration: none;
			white-space: nowrap;
			transition: background-color 0.25s ease-out;
		}
		.familySelectorOption.selected {
			color: var(--fix-color-white);
			background-color: var(--fix-color-selected);
		}
		.familySelectorOption:hover {
			background-color: var(--fix-color-selected);
		}

	`;

	@property()
	active = false;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.status = state.status;
		this.host = state.status.host;
		this.lang = state.status.lang;
		this.region = state.status.region;
		this.families = familyConfig;
		if (this.lang && this.lang !== '') {
			// wait for language to be available
			// convert this.families object to array and put the objects ids into each item
			this.familiesArray = Object.entries(this.families)
				.map(([name, config]) => ({id: name, ...config}))
				.filter(family => family.hasWizard)
				.sort((a, b) => a.label[this.lang].localeCompare(b.label[this.lang]));
		} else {
			this.familiesArray = null;
		}
	}

	connectedCallback() {
		super.connectedCallback();
		addEventListener('click', (e) => this.clickOutside(e, this));
	}

	disconnectedCallback() {
		super.disconnectedCallback();
		removeEventListener('click', (e) => this.clickOutside(e, this));
	}

	clickOutside(e, that) {
		const path = e.composedPath().map(el => el.id);
		if (!path.includes('familySelector')) {
			that.close();
		}
	}
	open(e) {
		this.active = !this.active;
	}
	close() {
		this.active = false;
	}
	familyUrl(familId) {
		const region = this.region;
		const lang = this.lang;

		let route = '';
		if (this.host === 'https://selux.com' || this.host === 'https://www.selux.cdlx.dev') {
			route = `/${region}/${lang}/datahub?family=${familId}`;
		} else {
			route = `/demo.php?region=${region}&lang=${lang}&family=${familId}`;
		}
		return route;
	}
	render() {
		if (!this.familiesArray) return null;

		const currentConfig = selectFamilyConfig(this.state);
		let familyLabel = msg('Choose a Product Family');
		if (currentConfig && currentConfig?.label) {
			familyLabel = currentConfig?.label[this.lang];
		}
		return html`
			<div class="familySelector" id="familySelector">
				<div class="familySelectorLabel" @click="${this.open}">
					<span class="text">${familyLabel}</span>
					<span class="icon">${down}</span>
				</div>
				<div id="familySelectorOptions" class="familySelectorOptions ${classMap({active: this.active})}">
					${repeat(
						this.familiesArray,
						(family) => family.id,
						(family) => html`
							<a href="${this.familyUrl(family.id)}"
							   class="familySelectorOption ${classMap({selected: selectFamily(this.state) === family.id})}">
								${family.label[this.lang]}
							</a>
						`)
					}
				</div>
			</div>
		`;
	}
}
